module.exports = __webpack_public_path__ + "img/7.b61aabb4.png";